import { Link } from 'react-router-dom';
import { spezie, biscotti } from '../../../mocks/products';

const FeaturedProducts = () => {
  const featured = [...spezie.slice(0, 3), ...biscotti.slice(0, 3)];

  return (
    <section className="py-24 bg-[#FAF8F5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-6 py-2 border border-[#2D5016] rounded-full mb-6">
            <span className="text-[#2D5016] text-sm font-medium">I Nostri Prodotti</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-serif font-light text-[#2D5016] mb-4">
            Esplora la Nostra<br />Selezione Artigianale
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {featured.map((product) => (
            <div
              key={product.id}
              className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 group cursor-pointer"
            >
              <div className="relative h-80 bg-gradient-to-br from-[#E8F5E9] to-[#F5F5DC] overflow-hidden">
                <img
                  src={product.immagine}
                  alt={product.nome}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4 px-3 py-1 bg-[#C17A5B] text-white text-xs font-medium rounded-full">
                  {product.categoria}
                </div>
              </div>

              <div className="p-6 text-center">
                <h3 className="text-xl font-semibold text-[#2D5016] mb-2">
                  {product.nome}
                </h3>
                <p className="text-gray-600 text-sm mb-6 line-clamp-2">
                  {product.descrizione}
                </p>
                <a
                  href="mailto:info@azienda.com"
                  className="w-4/5 mx-auto block px-6 py-3 bg-black text-white rounded-full text-sm font-medium hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Info-disponibilità-prezzi x mail
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/prodotti"
            className="inline-flex items-center px-8 py-4 border-2 border-[#2D5016] text-[#2D5016] rounded-full text-base font-medium hover:bg-[#2D5016] hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Vedi Tutti i Prodotti
            <i className="ri-arrow-right-line ml-2"></i>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
